import { dataIsValid } from 'shared/utils';

function selectCreditScorefromProfile(profile) {
	if (!dataIsValid(profile)) return null;

	if (dataIsValid(profile?.mfiCreditScore) && profile.mfiCreditScore !== 0)
		return profile.mfiCreditScore;

	return profile?.creditScore ?? 0;
}

export default selectCreditScorefromProfile;
